import {
  atsJobDetailsApiActions,
  getAtsJobDetails,
} from '@/store/atsJobDetails';
import { useDispatch, useSelector } from 'react-redux';

export const useApplicationHelper = () => {
  const dispatch = useDispatch();
  const { currentApplication } = useSelector(getAtsJobDetails);
  const { isLoading, data: applicationData } = currentApplication;

  // Returns the dispatch promise so a caller that must not close its UI until
  // the stage really has the new data can await it. Every existing caller
  // ignores it and keeps the old fire-and-forget behaviour.
  const refetchApplication = () => {
    if (!applicationData?.id) return Promise.resolve();
    return dispatch(
      atsJobDetailsApiActions('getCurrentApplication', {
        pathParams: { applicationId: applicationData?.id },
        requestConfig: { params: { include: ['stage_actions'] } },
        isBackground: true,
      })
    );
  };

  return { applicationData, isLoading, refetchApplication };
};
